import apiService from 'services/api.service'
import store from 'store'

export default {
    async getHotels() {
        const lang = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'claims/getHotelList',
                method: 'get',
                params: {},
                locale: lang
            }).then(response => {
                if (response.data.data) {
                    resolve(response.data.data);
                } else {
                    reject('empty hotels!');
                }
            }).catch((error) => {
                reject(error);
            });
        });
    },

    async getMessages(params) {
        const lang = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'messages/getMessages',
                method: 'get',
                params: params,
                locale: lang
            }).then(response => {
                if (response.data.data) {
                    const messages = response.data.data;
                    resolve(messages);
                } else {
                    reject('empty messages!');
                }
            }).catch((error) => {
                reject(error);
            });
        });
    },

    async sendMessage(params) {
        const lang = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'messages/sendMessage',
                method: 'get',
                params: params,
                locale: lang
            }).then(response => {
                resolve(response.data);
            }).catch((error) => {
                reject(error);
            });
        });
    },

    async setRead(params) {
        const lang = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'messages/setRead',
                method: 'get',
                params: params,
                locale: lang
            }).then(response => {
                resolve(response.data);
            }).catch((error) => {
                reject(error);
            });
        });
    },

    async getUnreadMessagesCount() {
        const lang = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'messages/getMessages',
                method: 'get',
                params: {type: 1},
                locale: lang
            }).then(response => {
                resolve(response.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }


}
